var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute top-0 left-0 right-0 bottom-0 h-full w-full flex justify-center items-center bg-stone-500 bg-opacity-50 z-50 cz3__popup-overlay"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }